/**
 * Display-only GST math for pre-checkout previews (blocker overlay,
 * connect-time pay screen, billing recharge modal).
 *
 * The rate is NOT hardcoded here: the server owns it (env `GST_RATE_PCT`) and
 * serves it via `useGstRate()`. If the two ever diverged, every "Pay ₹X" label
 * would disagree with what Razorpay actually charges. The constant below is
 * only the fallback used before the rate query resolves.
 *
 * Every recharge amount in the app is the WALLET CREDIT (taxable value);
 * the customer pays credit + GST at checkout.
 */
export const FALLBACK_GST_RATE_PCT = 18;

/**
 * GST charged on top of a wallet-credit amount, ₹ (2dp).
 * Mirrors the server's order-creation math exactly: round to paise here, then
 * add — reversing the order would drift a paisa against the Razorpay order.
 */
export function gstOn(creditInr: number, ratePct: number): number {
  if (!Number.isFinite(creditInr) || !Number.isFinite(ratePct) || ratePct <= 0) return 0;
  return +((creditInr * ratePct) / 100).toFixed(2);
}

/** Total payable at checkout for a wallet-credit amount, ₹ (2dp). */
export function withGst(creditInr: number, ratePct: number): number {
  if (!Number.isFinite(creditInr)) return 0;
  return +(creditInr + gstOn(creditInr, ratePct)).toFixed(2);
}
